module.exports = "<div [ngClass]=\"class\">\n\t<label>\n\t  <input type=\"checkbox\" class=\"ace ace-switch ace-switch-6\" (click)=\"onInputChange($event)\" />\n\t  <span class=\"lbl\"></span>\n\t</label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/switch/switch.html
// module id = 542
// module chunks = 0